import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <g id="Vector">
        <path
          d="M13.19 1C12.7608 1 12.3618 1.22113 12.1343 1.58513L7.5 9V21H18.2639C19.0215 21 19.714 20.572 20.0528 19.8944L22.0777 15.8446C22.3554 15.2892 22.5 14.6767 22.5 14.0557V10C22.5 8.89543 21.6046 8 20.5 8H14L15.016 3.25871C15.2651 2.09621 14.3789 1 13.19 1Z"
          fill="#D1D1D1"
        />
        <path
          d="M2 10C2 9.44772 2.44772 9 3 9H6V21H3C2.44772 21 2 20.5523 2 20V10Z"
          fill="#D1D1D1"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponent;
